import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./adminlogin.css"; // Reuse the same CSS file for styling
import logo from './Unext_Logo(Black).png';
const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      //      const response = await fetch('http://localhost:3001/auth/login', {
      
              const response = await fetch('/api/admin/login', {
        
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({ email,password }),
            });
      
            const data = await response.json();
      
            if (data.success) {
              // Save username in localStorage or pass it as state
             // localStorage.setItem('username', data.username);
              localStorage.setItem('email', data.email);
              
            //  navigate('/admin/dashboard');
navigate('/admin/home');
            } else {
              setError(data.message);
            }
          } catch (error) {
            setError('An error occurred. Please try again.');
          }
        };

  return (
    <div className="adminlogin-page">
      <div className="adminform-container">
      <div className="admin-logo-conatiner">
          <img src={logo} alt="Logo" className="admin-logo" />
          </div>
        <h2 className="adminh2">Admin</h2>
        
        {error && <div className="adminerror">{error}</div>}
        <form onSubmit={handleLogin}>
          <label htmlFor="adminemail">Email</label>
          <input
            type="email"
            id="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <label htmlFor="password">Password</label>
          <input
            type="password"
            id="adminpassword"
            placeholder="Enter your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button type="submit" className="adminsubmit-button">
            Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
